import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05aa78c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-corpo-resultado" }
const _hoisted_2 = {
  class: "ant-row",
  style: {"min-height":"50px"}
}
const _hoisted_3 = { class: "ant-col ss-titulo-resultado" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_7 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-top":"1px","margin-bottom":"1px"}
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  style: {"overflow":"auto","max-height":"300px","margin-bottom":"10px"}
}
const _hoisted_11 = { class: "ant-col ss-botao-expandir" }
const _hoisted_12 = ["name"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_resultado_d_r_e = _resolveComponent("resultado-d-r-e")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass('ant-col ant-col-xl-1 ss-tipo-resultado ' + _ctx.obterClasseGrupo()),
        style: {"flex":"0 0 30px"}
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.obterSimboloGrupo()), 1)
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.props.grupo.descricao), 1),
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editarGrupo && _ctx.editarGrupo(...args)))
                }, [
                  _createVNode(_component_icone, { nome: "editar" })
                ])
              ])
            ]),
            (_ctx.UtilitarioGeral.objetoValido(_ctx.props.grupo.resultado))
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.props.grupo.resultado.totais, (total, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "ant-col ss-coluna-resultado",
                    key: index
                  }, _toDisplayString((_ctx.props.grupo.tipo == 2  && total > 0? '-' : '') + _ctx.UtilitarioMascara.mascararValor(total, 2, false, true)), 1))
                }), 128))
              : _createCommentVNode("", true)
          ]),
          (_ctx.UtilitarioGeral.objetoValido(_ctx.props.grupo.resultado) && _ctx.state.expandir)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.state.expandir)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.grupo.resultado.itens, (item, index) => {
                  return (_openBlock(), _createBlock(_component_resultado_d_r_e, {
                    key: index,
                    "tipo-grupo": _ctx.props.grupo.tipo,
                    resultado: item
                  }, null, 8, ["tipo-grupo", "resultado"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.UtilitarioGeral.objetoValido(_ctx.props.grupo.resultado) && _ctx.UtilitarioGeral.validaLista(_ctx.props.grupo.resultado.itens) && _ctx.props.grupo.tipo !== _ctx.ETipoGrupoDRE.Totalizador)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.expandir && _ctx.expandir(...args))),
              name: _ctx.state.expandir ? 'Contrair' : 'Expandir'
            }, [
              _createVNode(_component_icone, {
                style: {"font-size":"24px"},
                nome: _ctx.state.expandir ? 'subir' : 'descer'
              }, null, 8, ["nome"])
            ], 8, _hoisted_12))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}